/**
 * @fileoverview Re-export of rate limiting utilities.
 *
 * This module re-exports rate limiting utilities from the api module
 * to maintain backward compatibility.
 */

export * from './api/rateLimiter';